import React, { useContext } from 'react'
import { Controller, useFormContext, useWatch } from 'react-hook-form'
import { Checkbox, Form } from 'semantic-ui-react'
import { FormFields } from '~/components/FormFields'
import { StyledGroup } from '../../../../Co2Climate/AnswerCO2Climate/Steps/GrassSilageStep/style'
import { StyledDivider } from '../ElevenStep/style'
import { SummaryOptionsContext } from '.'
import InfoPopup from '~/components/InfoPopup'
import ErrorIcon from '../ErrorIcon'

const SozialesStep: React.FC = () => {
  const { control, setValue, clearErrors } = useFormContext()
  const {
    daysOffPerWeekOptions,
    vacationPerYearOptions,
    workloadOptions,
    voluntaryEngagementOptions
  } = useContext(SummaryOptionsContext)

  const watchPublicRelations = useWatch({ control, name: 'additionalQuestions.companyPublicRelationsEngagement' })
  const watchDaysOff = useWatch({ control, name: 'additionalQuestions.daysOffPerWeek' })
  const watchVacation = useWatch({ control, name: 'additionalQuestions.vacationPerYear' })
  const watchWorkload = useWatch({ control, name: 'additionalQuestions.workload' })
  const watchVoluntaryEngagement = useWatch({ control, name: 'additionalQuestions.voluntaryEngagement' })

  return (
    <div style={{ marginTop: '2em' }}>
      <StyledGroup widths={'equal'}>
        <Controller
          control={control}
          name='additionalQuestions.daysOffPerWeek'
          rules={{ required: true }}
          render={({ fieldState: { error } }) => (
            <Form.Field error={Boolean(error)}>
              <label className='title' style={{ width: 'fit-content' }}>
                <div>{'Regelmäßig freie Tage pro Woche im letzten Jahr für die Betriebsleitung bzw. Bereichsleitung Milch'}</div>
                <StyledDivider />
              </label>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 15 }}>
                {daysOffPerWeekOptions.map(option => (
                  <Checkbox
                    radio
                    key={option.key}
                    label={option.label}
                    checked={watchDaysOff === option.key}
                    onClick={() => {
                      setValue('additionalQuestions.daysOffPerWeek', option.key)
                      clearErrors('additionalQuestions.daysOffPerWeek')
                    }}
                  />
                ))}
              </div>
            </Form.Field>
          )}
        />
      </StyledGroup>

      <StyledGroup widths={'equal'}>
        <Controller
          control={control}
          name='additionalQuestions.vacationPerYear'
          rules={{ required: true }}
          render={({ fieldState: { error } }) => (
            <Form.Field error={Boolean(error)}>
              <label className='title' style={{ width: 'fit-content' }}>
                <div>{'Urlaubszeit der Betriebsleitung bzw. Bereichsleitung Milch im letzten Jahr'}</div>
                <StyledDivider />
              </label>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 15 }}>
                {vacationPerYearOptions.map(option => (
                  <Checkbox
                    radio
                    key={option.key}
                    label={option.label}
                    checked={watchVacation === option.key}
                    onClick={() => {
                      setValue('additionalQuestions.vacationPerYear', option.key)
                      clearErrors('additionalQuestions.vacationPerYear')
                    }}
                  />
                ))}
              </div>
            </Form.Field>
          )}
        />
      </StyledGroup>

      <StyledGroup widths={'equal'}>
        <Controller
          control={control}
          name='additionalQuestions.workload'
          rules={{ required: true }}
          render={({ fieldState: { error } }) => (
            <Form.Field error={Boolean(error)}>
              <label className='title' style={{ width: 'fit-content' }}>
                <div>{'Arbeitssituation/Arbeitsbelastung im Gesamtbetrieb'}</div>
                <StyledDivider />
              </label>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 15 }}>
                {workloadOptions.map(option => (
                  <Checkbox
                    radio
                    key={option.key}
                    label={option.label}
                    checked={watchWorkload === option.key}
                    onClick={() => {
                      setValue('additionalQuestions.workload', option.key)
                      clearErrors('additionalQuestions.workload')
                    }}
                  />
                ))}
              </div>
            </Form.Field>
          )}
        />
      </StyledGroup>

      <StyledGroup widths={'equal'}>
        <Controller
          control={control}
          name='additionalQuestions.companyPublicRelationsEngagement'
          rules={{
            required: true
          }}
          render={({ fieldState: { error } }) => (
            <Form.Field error={Boolean(error)}>
              <label className='title' style={{ width: 'fit-content' }}>
                <div style={{ display: 'flex', alignItems: 'baseline', gap: 5 }}>
                  <div>{'Engagement des Betriebes in der Öffentlichkeitsarbeit'}</div>
                  <InfoPopup
                    position={'top center'}
                    content={`Engagement in der Öffentlichkeitsarbeit umfasst alle Aktivitäten, bei denen Sie aktiv den Austausch mit Verbrauchern, Medien, 
                      Politik oder lokalen Gemeinschaften suchen oder gestalten, um Einblicke in die landwirtschaftliche Arbeit zu geben, 
                      Verständnis zu fördern und das Bild der Landwirtschaft positiv zu prägen.`}
                    styleIcon={{ fontSize: '1.2em' }}
                  />
                </div>
                <StyledDivider />
              </label>
              <div style={{ display: 'flex', gap: 20 }}>
                <Checkbox
                  radio
                  label={'Ja'}
                  checked={watchPublicRelations === 1}
                  onClick={() => {
                    setValue('additionalQuestions.companyPublicRelationsEngagement', 1)
                    clearErrors('additionalQuestions.companyPublicRelationsEngagement')
                  }}
                />
                <Checkbox
                  radio
                  label={'Nein'}
                  checked={watchPublicRelations === 0}
                  onClick={() => {
                    setValue('additionalQuestions.companyPublicRelationsEngagement', 0)
                    clearErrors('additionalQuestions.companyPublicRelationsEngagement')
                  }}
                />
              </div>
            </Form.Field>
          )}
        />
      </StyledGroup>

      <StyledGroup widths={'equal'}>
        <Controller
          control={control}
          name='additionalQuestions.voluntaryEngagement'
          rules={{ required: true }}
          render={({ fieldState: { error } }) => (
            <Form.Field error={Boolean(error)}>
              <label className='title' style={{ width: 'fit-content' }}>
                <div>{'Ehrenamtliches Engagement'}</div>
                <StyledDivider />
              </label>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 15 }}>
                {voluntaryEngagementOptions.map(option => (
                  <Checkbox
                    radio
                    key={option.key}
                    label={option.label}
                    checked={watchVoluntaryEngagement === option.key}
                    onClick={() => {
                      setValue('additionalQuestions.voluntaryEngagement', option.key)
                      clearErrors('additionalQuestions.voluntaryEngagement')
                    }}
                  />
                ))}
              </div>
            </Form.Field>
          )}
        />
      </StyledGroup>

      <StyledGroup widths={'equal'}>
        <FormFields.Input
          control={control}
          rules={{
            required: true,
            validate: (value) => {
              const transformValue = typeof (value) === 'string' ? parseFloat(value.replace(',', '.')) : value
              if (transformValue > 100) {
                return 'Der eingegebene Wert darf maximal 100 betragen.'
              }

              if (transformValue < 1) {
                return 'Der eingegebene Wert muss mindestens 1 betragen.'
              }

              return true
            }
          }}
          withoutAsterisk
          noErrorMessage
          typeInput='controled'
          label={<div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
            <label>{'Wie viele Personen arbeiten auf Ihrem Betrieb'}</label>
            <ErrorIcon
              control={control}
              name={'additionalQuestions.totalWorkers'}
            />
          </div>}
          placeholder={'Anzahl'}
          name={'additionalQuestions.totalWorkers'}
        />
      </StyledGroup>

      <StyledGroup widths={'equal'}>
        <FormFields.Input
          control={control}
          rules={{
            required: true,
            validate: (value) => {
              const transformValue = typeof (value) === 'string' ? parseFloat(value.replace(',', '.')) : value
              if (transformValue > 120) {
                return 'Der eingegebene Wert darf maximal 120 Stunden betragen.'
              }

              if (transformValue < 1) {
                return 'Der eingegebene Wert muss mindestens 1 Stunde betragen.'
              }

              return true
            }
          }}
          withoutAsterisk
          noErrorMessage
          typeInput='controled'
          label={<div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
            <label>{'Wie viele Wochenstunden arbeitet die Betriebsleitung durchschnittlich?'}</label>
            <ErrorIcon
              control={control}
              name={'additionalQuestions.averageManagementWeeklyHours'}
            />
          </div>}
          suffix=' Stunden'
          placeholder={'in Stunden'}
          name={'additionalQuestions.averageManagementWeeklyHours'}
        />
      </StyledGroup>

      <StyledGroup widths={'equal'}>
        <FormFields.Input
          control={control}
          rules={{
            required: true,
            validate: (value) => {
              const transformValue = typeof (value) === 'string' ? parseFloat(value.replace(',', '.')) : value
              if (transformValue > 80) {
                return 'Der eingegebene Wert darf maximal 80 Jahre betragen.'
              }

              if (transformValue < 18) {
                return 'Der eingegebene Wert muss mindestens 18 Jahre betragen.'
              }

              return true
            }
          }}
          withoutAsterisk
          noErrorMessage
          typeInput='controled'
          label={<div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
            <label>{'Alter der Betreibsleitung '}</label>
            <ErrorIcon
              control={control}
              name={'additionalQuestions.ageOfManagement'}
            />
          </div>}
          suffix=' Jahre'
          placeholder={'in Jahren'}
          name={'additionalQuestions.ageOfManagement'}
        />
      </StyledGroup>
    </div>
  )
}

export default SozialesStep
